const arraysDontMatch = (arr1, arr2) => arr1.length !== arr2.length ||
  !arr1.every(item => arr2.includes(item))
const isObject = obj => obj === Object(obj) && !Array.isArray(obj)
const isNotEmptyObject = obj => Object.keys(obj).length > 0

const getChangedAttributes = (newObject = {}, oldObject = {}) =>
  Object.entries(newObject).reduce((acc, [key, newAttr]) => {
    if (newAttr !== oldObject[key]) {
      const oldAttr = oldObject[key]

      if (Array.isArray(newAttr) && Array.isArray(oldAttr)) {
        if (arraysDontMatch(newAttr, oldAttr) && newAttr.length > 0) {
          acc[key] = newAttr
        }
      } else if (isObject(newAttr) && isObject(oldAttr)) {
        const changedAttr = getChangedAttributes(newAttr, oldAttr)

        if (isNotEmptyObject(changedAttr)) {
          acc[key] = newAttr
        }
      } else {
        acc[key] = newAttr
      }
    }

    return acc
  }, {})

export default getChangedAttributes
